import { forwardRef } from 'react'

//* HOC
import { withLanguageContext } from 'context'

//* Component
import Translate from '../Translate'

const Text = forwardRef((props, ref) => {
    let string = (
        <Translate
            val={props.text}
            vars={props.vars}
        />
    )

    switch (props.tag) {
        case 'h1':
            string = (
                <h1
                    ref={ref}
                    data={props.data}
                    style={props.style}
                    onClick={props.onClick}
                    onMouseEnter={props.onMouseEnter}
                    className={`comp-title ${props.className || 'h1'} ${props.uppercase ? 'uppercase' : ''}`}
                    {...props.attr}
                >
                    {props.children || string}
                </h1>
            )
            break
        case 'h2':
            string = (
                <h2
                    ref={ref}
                    data={props.data}
                    style={props.style}
                    onClick={props.onClick}
                    onMouseEnter={props.onMouseEnter}
                    className={`comp-title ${props.className || 'h2'} ${props.uppercase ? 'uppercase' : ''}`}
                    {...props.attr}
                >
                    {props.children || string}
                </h2>
            )
            break
        case 'h3':
            string = (
                <h3
                    ref={ref}
                    data={props.data}
                    style={props.style}
                    onClick={props.onClick}
                    onMouseEnter={props.onMouseEnter}
                    className={`comp-title ${props.className || 'h3'} ${props.uppercase ? 'uppercase' : ''}`}
                    {...props.attr}
                >
                    {props.children || string}
                </h3>
            )
            break
        case 'h4':
            string = (
                <h4
                    ref={ref}
                    data={props.data}
                    style={props.style}
                    onClick={props.onClick}
                    onMouseEnter={props.onMouseEnter}
                    className={`comp-title ${props.className || 'h4'} ${props.uppercase ? 'uppercase' : ''}`}
                    {...props.attr}
                >
                    {props.children || string}
                </h4>
            )
            break
        case 'h5':
            string = (
                <h5
                    ref={ref}
                    data={props.data}
                    style={props.style}
                    onClick={props.onClick}
                    onMouseEnter={props.onMouseEnter}
                    className={`comp-title ${props.className || 'h5'} ${props.uppercase ? 'uppercase' : ''}`}
                    {...props.attr}
                >
                    {props.children || string}
                </h5>
            )
            break
        case 'h6':
            string = (
                <h6
                    ref={ref}
                    data={props.data}
                    style={props.style}
                    onClick={props.onClick}
                    onMouseEnter={props.onMouseEnter}
                    className={`comp-title ${props.className || 'h6'} ${props.uppercase ? 'uppercase' : ''}`}
                    {...props.attr}
                >
                    {props.children || string}
                </h6>
            )
            break
        case 'label':
            string = (
                <label
                    ref={ref}
                    style={props.style}
                    onClick={props.onClick || null}
                    className={`comp-title ${props.className || ''} ${props.uppercase ? 'uppercase' : ''}`}
                    {...props.attr}
                >
                    {props.children || string}
                </label>
            )
            break
        case 'span':
            string = (
                <span
                    ref={ref}
                    style={props.style}
                    className={`comp-title ${props.className || ''} ${props.uppercase ? 'uppercase' : ''}`}
                    onClick={props.onClick || null}
                    {...props.attr}
                >
                    {props.children || string}
                </span>
            )
            break
        case 'div':
            string = (
                <div
                    ref={ref}
                    style={props.style}
                    onClick={props.onClick || null}
                    className={`comp-title ${props.className || ''} ${props.uppercase ? 'uppercase' : ''}`}
                    {...props.attr}
                >
                    {props.children || string}
                </div>
            )
            break
        default:
            string = (
                <p
                    ref={ref}
                    data={props.data}
                    style={props.style}
                    onClick={props.onClick}
                    onMouseEnter={props.onMouseEnter}
                    className={`comp-title ${props.className || 'p'} ${props.uppercase ? 'uppercase' : ''}`}
                    {...props.attr}
                >
                    {props.children || string}
                </p>
            )
    }

    return string
})

Text.displayName = 'Text'

export default withLanguageContext(Text, ['translate'])
